<template>
  <main class="app" :class="{ 'app_search-expanded': isSearchExpanded }">
    <notifications
      classes="notification"
      :duration="5000"
      :width="notificationWidth"
    />
    <banner />
    <topbar />
    <section id="content" class="content container">
      <banner-slider/>
      <keep-alive include="search">
        <router-view />
      </keep-alive>
    </section>
    <bottombar />
    <modals />
  </main>
</template>

<script>
import Banner from '@/components/Banner';
import Topbar from '@/components/Topbar';
import Bottombar from '@/components/Bottombar';
import Modals from '@/components/Dialog';
import BannerSlider from '@/components/BannerSlider';
import Cookies from 'js-cookie';
import 'airbnb-browser-shims';
import axios from 'axios';

export default {
  components: {
    Topbar,
    Banner,
    Bottombar,
    Modals,
    BannerSlider,
  },
  data() {
    return {
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    isSearchExpanded() {
      return this.$store.getters.isSearchExpanded;
    },
    notificationWidth() {
      return this.screenWidth < 500 ? '100%' : '300px';
    },
  },
  methods: {
    getData() {
      return Promise.allSettled([
        this.$store.dispatch('getConfig', false),
        this.$store.dispatch('getGenres'),
        this.$api.getPromotions()
          .then((response) => {
            this.$store.commit('promos', response);
          }),
        this.$store.dispatch('getDevices', false),
      ]);
    },
  },
  watch: {
    // eslint-disable-next-line
    '$route.query.ref_code': function () {
      this.handleRefCode();
    },
  },
  serverPrefetch() {
    return this.getData();
  },
  created() {
    if (Cookies.get('lt')) {
      this.$store.commit('lt', Cookies.get('lt'));
      Cookies.remove('lt', {
        path: '',
        domain: '.appdb.to',
      });
    }

    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get('lt')) {
        this.$store.commit('lt', params.get('lt'));
      }
      if (params.get('ref')) {
        this.$store.commit('ref', params.get('ref'));
      }
      // eslint-disable-next-line no-empty
    } catch {
    }

    const version = this.$store.getters.appVersion;

    function checkNewVersion() {
      axios({
        method: 'GET',
        url: `/version.txt?${Math.random()}`,
        withCredentials: true,
      })
        .then((response) => {
          if (response.data) {
            if (response.data !== version) {
              setTimeout(() => {
                try {
                  const url = new URL(window.location.href);
                  url.searchParams.append('', Math.random());
                  window.location.href = url.href;
                } catch {
                  window.location.href = `${window.location.origin}${window.location.pathname}?${Math.random()}`;
                }
              }, 3 * 1000);
            }
          }
        });
    }

    setInterval(() => {
      if (this.$store.getters.lt) {
        this.$store.dispatch('getDevices');
        this.$store.dispatch('getConfig');
      }
    }, 30 * 1000);


    checkNewVersion();

    setInterval(() => {
      checkNewVersion();
    }, 60 * 1000);


    this.getData();

    window.addEventListener('resize', () => {
      this.screenWidth = window.innerWidth;
    });
  },
};
</script>

<style lang="scss">
@import "reset-css";
@import url("https://fonts.googleapis.com/css?family=IBM+Plex+Sans:400,500,600,700&display=swap&subset=cyrillic");
@import "./assets/variables";
@import "vue-select/src/scss/vue-select.scss";

* {
  box-sizing: border-box;
}

html,
body {
  overflow-x: hidden;
}

body {
  position: relative;
  font-size: $text-primary-size;
  font-family: "IBM Plex Sans", sans-serif;
  color: var(--text-primary);
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
  text-size-adjust: none;
  background: var(--bg);

  @media (min-device-width: 768px) and (min-device-height: 768px) {
    min-width: 1250px;
  }
}

@media screen and (max-device-width: 480px) {
  body {
    -webkit-text-size-adjust: 100%;
  }
}

input,
textarea {
  -webkit-appearance: none;
  transition: border 0.3s;

  &:focus {
    border-color: $dark-primary !important;
    outline: none;
  }
}

button {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;

  &:focus {
    outline: none;
  }
}

a {
  text-decoration: none;
  color: $primary;
  font-weight: 500;
}

strong {
  font-weight: 500;
}

.container {
  width: 1220px;
  margin: 0 auto;
  position: relative;

  @include notebook {
    width: 100%;
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
}

.g-text {
  line-height: 18px;

  &_justify {
    text-align: justify;
  }

  b {
    font-weight: 700;
  }
}

.g-status {
  display: inline-block;
  background: #ededed;
  border-radius: 2.5px;
  font-size: 12px;
  padding: 3px;
  color: #525d66;

  &_success {
    background: var(--bg-success);
    color: #053305;
  }

  &_error {
    background: var(--bg-error);
    color: var(--text-primary);
  }

  &_warning {
    background: var(--bg-warning);
    color: var(--text-primary);
  }
}

.g-text-success {
  color: var(--text-success);
}

.g-text-warning {
  color: var(--text-warning);
}

.g-text-error {
  color: var(--text-error);
}

.g-button {
  display: inline-block;
  position: relative;
  padding: 4px 8px;
  background: var(--bg);
  border: 1px solid lighten($primary, 20%);
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  cursor: pointer;

  &_primary {
    background-color: $primary;
    color: #fff;
  }

  &_disabled {
    pointer-events: none;
  }
}

.g-pro {
  display: inline-block;
  text-transform: uppercase;
  background: #016cfa;
  font-size: 11px;
  font-weight: 700;
  color: #fff;

  border-radius: 3px;
  padding: 0px 3px;
}

.g-code {
  display: flex;

  @include notebook {
    flex-direction: column;
    align-items: center;
  }

  &__input {
    background: var(--tertiary-bg);
    border: 1px solid var(--tertiary-accent);
    border-radius: 2px;
    flex-grow: 1;
    padding: 8px;
    font-weight: 600;
    text-align: center;
    letter-spacing: 1px;
    font-size: 14px;
    color: var(--text-primary);

    @include tablet {
      font-size: 16px;
    }

    &::placeholder {
      color: var(--text-primary);
      opacity: 0.4;
    }

    @include notebook {
      max-width: 256px;
      width: 100%;
    }
  }

  &__button {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: $primary;
    color: #fff;
    padding: 10px;
    font-weight: 500;
    background: $primary;
    box-shadow: 0 2px 4px 0 rgba(35, 69, 114, 0.3);
    border-radius: 2px;
    position: relative;
    margin-left: -2px;

    @include notebook {
      margin-left: 0;
      margin-top: 5px;
      max-width: 256px;
      width: 100%;
      justify-content: center;
    }

    &_loading {
      pointer-events: none;

      .g-code__loader {
        display: block;
      }

      &:before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: $primary;
        z-index: 1;
      }
    }
  }

  &__loader {
    display: none;

    &,
    &:after {
      border-radius: 50%;
      width: 18px;
      height: 18px;
    }

    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    position: absolute;
    z-index: 2;
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-left: 2px solid #fff;
    transform: translateZ(0);
    animation: load 1.1s infinite linear;

    @keyframes load {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }

  &__icon {
    position: relative;
    top: 1px;
    margin-right: 5px;
  }
}

.notification {
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  overflow: hidden;
  margin: 10px 10px 0 0;
  font-size: 16px;
  padding: 15px;
  background: #ededed;
  color: #525d66;

  @media (max-width: 499px) {
    margin: 10px 10px 0;
  }

  .notification-title {
    margin-bottom: 5px;
  }

  .notification-content {
    word-break: break-word;
  }

  &.success {
    background: var(--bg-success);
    color: #053305;
  }

  &.error {
    background: var(--bg-error);
    color: var(--text-primary);
  }

  &.warning {
    background: var(--bg-warning);
    color: var(--text-primary);
  }
}
</style>

<style lang="scss" scoped>
@import "./assets/variables";

.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  &:before {
    content: "";
    display: block;
    width: 100%;
    height: 3px;
    background-image: var(--body-top-border-gradient);
  }

  &_search-expanded {
    @include notebook {
      &:after {
        content: "";
        display: block;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.3);
        z-index: 5;
      }
    }
  }
}

.content {
  padding-top: 87px;
  padding-bottom: 40px;

  @include notebook {
    padding-top: 67px;
  }
}
</style>
